import axios from 'axios';

const { application, _FE_version } = window;
const { environment, region, device_id } = application.params;

const plexURL = 'https://nxl.log.nexon.io/';

const send = async (log_type: string, data: any) => {
    try {
        if (environment !== 'live') log_type = `${environment}-${log_type}`;
        data.log_type = log_type;

        if (application.userNo) {
            data.user_no = application.userNo;
        }
        if (application.globalUserNo) {
            data.global_user_no = application.globalUserNo;
        }

        await axios.post(plexURL, {
            device_id,
            region,
            nxl_session_id: application.sessionId,
            nxl_version: _FE_version,
            timestamp: Date.now(),
            ...data,
        });
    } catch (e) {
        console.debug(e);
    }
};

//
const sendError = (error_type: string, reason: any, opts = {}) => {
    return send('nxl-error-frontend', { error_type, reason: JSON.stringify(reason), ...opts });
};

const sendStats = (event_name: string, type: string, productId: string, extra: object | undefined = undefined) => {
    const data: any = {
        event_name,
        type,
    };
    if (productId) {
        data.product_id = productId;
    }
    if (extra) {
        Object.assign(data, extra);
    }
    send('nxl-stats', data);
};

const plex = {
    // sendStats: (...args: any) => {
    //     window.coreappIpc.send('plexSendStats', ...args);
    // },
    sendStats,
    sendPartner: (...args: any) => {
        window.coreappIpc.send('plexSendPartner', ...args);
    },
    sendError,
};

export default plex;
